import { Component, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProfileService } from 'src/app/_services/profile.service';
import { Response } from 'src/app/models/response';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import Swal from 'sweetalert2';
import { AspirationService } from 'src/app/_services/aspiration.service';

@Component({
  selector: 'app-card-convinzioni',
  templateUrl: './card-limitazioni.component.html',
  styleUrls: ['./card-limitazioni.component.css'],
})
export class CardConvinzioniComponent {
  @ViewChildren('des') childInput!: QueryList<ElementRef>;
  @ViewChildren('editBtn') childEditBtn!: QueryList<ElementRef>;
  @ViewChildren('doneBtn') childDoneBtn!: QueryList<ElementRef>;
  inputI: number;
  editControl: boolean = false;

  limitations: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  completedArray: any;
  incompletedArray: any;
  result: any = [];
  description: string;
  limitationArray = [];
  completedLimitationsPercentage = 0;
  completedLimitations = 0;
  valueMax = 0;
  count_limitazioni: any;

  constructor(
    private profileService: ProfileService,
    private aspirationService: AspirationService
  ) {}

  ngOnInit(): void {
    this.getLimitations();
  }

  getLimitations() {
    this.aspirationService.getAspirations().subscribe({
      next: (res: any) => {
        {
          this.limitations.next(res.limitations);

          this.limitations.subscribe((x) => (this.limitationArray = x));

          this.completedLimitationsPercentage =
            (res.completed_limitations * 100) / this.limitationArray.length;
          this.completedLimitations = res.completed_limitations;
          this.count_limitazioni = res.countLimitazioni;
          this.valueMax = res.countLimitazioni * 100;

          this.completedArray = this.limitationArray.filter((obj: any) => {
            return obj.is_checked == 1;
          });

          this.incompletedArray = this.limitationArray.filter((obj: any) => {
            return obj.is_checked == 0;
          });
        }
      },
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.limitations.value,
      event.previousIndex,
      event.currentIndex
    );

    this.aspirationService.switch(this.limitationArray).subscribe({
      next: (res: Response<any>) => {
        {
          this.getLimitations();
        }
      },
    });
  }

  addLimitation(
    description: string = '',
    is_limitation: boolean = true,
    is_checked: boolean = false
  ): void {
    if (description.trim() !== '') {
      this.aspirationService
        .storeAspiration(description, is_limitation, is_checked)
        .subscribe({
          next: (res: Response<any>) => {
            {
              this.getLimitations();
              this.description = '';

              Swal.fire({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
                icon: 'success',
                iconColor: '#FFB26B',
                title: 'Limitazione aggiunta',
                didOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer);
                  toast.addEventListener('mouseleave', Swal.resumeTimer);
                },
              });
            }
          },
        });
    }
  }

  enableEditMode(index: number) {
    this.inputI = index;
    this.editControl = true;

    this.childInput.find((_, i) => i == index)!.nativeElement.disabled = false;
    this.childEditBtn.find(
      (_, i) => i == this.inputI
    )!.nativeElement.style.display = 'none';
    this.childDoneBtn.find(
      (_, i) => i == this.inputI
    )!.nativeElement.style.display = 'block';
  }

  disableEditMode() {
    if (this.inputI != undefined) {
      this.childInput.find((_, i) => i == this.inputI)!.nativeElement.disabled =
        false;
      this.childEditBtn.find(
        (_, i) => i == this.inputI
      )!.nativeElement.style.display = 'block';
      this.childDoneBtn.find(
        (_, i) => i == this.inputI
      )!.nativeElement.style.display = 'none';
    }
    this.editControl = false;
  }

  updateLimitation(
    limitationId: number,
    description: string,
    checked: boolean
  ) {
    this.aspirationService
      .updateASpiration(limitationId, description, checked)
      .subscribe({
        next: (res: Response<any>) => {
          {
            this.getLimitations();
            this.disableEditMode();

            Swal.fire({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              icon: 'success',
              iconColor: '#FFB26B',
              title: 'Limitazione aggiornata',
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
              },
            });
          }
        },
      });
  }

  deleteLimitation(id: number): void {
    Swal.fire({
      text: 'Sicuro di voler eliminare questa convinzione limitante?',
      showCancelButton: true,
      cancelButtonText: 'Annulla',
      cancelButtonColor: '#00337C',
      showConfirmButton: true,
      confirmButtonText: 'Conferma',
      confirmButtonColor: '#FFB26B',
      reverseButtons: true,
      focusConfirm: false,
      customClass: {
        popup: 'main-font',
      },
      backdrop: '#f4f3efad',
      position: 'center',
    }).then((result) => {
      if (result.isConfirmed) {
        this.aspirationService.deleteAspiration(id).subscribe({
          next: (res: Response<any>) => {
            {
              this.getLimitations();
            }
          },
        });

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: 'Limitazione eliminata',
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          },
        });
      }
    });
  }
}
